import { ButtonLoading } from 'components/Buttons'
import { Modal } from 'components/Modal'
import { useWizardForm } from 'store/useWizardForm'
import FormattedMessage from 'utils/FormattedMessage'
import { TIMESLOT_STEP } from '../useWizardSteps'
import { useWizardSteps } from '../useWizardSteps'

const CACTUS_SVG = '/cactus.svg'

interface SlotTakenWarningProps {
  open: boolean
}

export const SlotTakenWarning = ({ open }: SlotTakenWarningProps) => {
  const { goToStep } = useWizardSteps()
  const { updateWizardForm } = useWizardForm()

  const handleChooseAnotherTime = () => {
    updateWizardForm({ selectedTime: undefined })
    goToStep(TIMESLOT_STEP)
  }

  return (
    <Modal open={open} closeIcon={false}>
      <div className='flex flex-col items-center bg-white p-5 w-full'>
        <img
          className='w-[150px] rounded-md mt-10 mb-7'
          src={CACTUS_SVG}
          alt='Slot taken'
        />
        <h1 className='text-gray-700 text-2xl font-bold text-center'>
          <FormattedMessage id='slotTaken' /> :(
        </h1>
        <p className='text-sm text-gray-800 text-center my-4 max-w-[80%]'>
          <FormattedMessage id='slotTaken.description' />
        </p>
        <ButtonLoading onClick={handleChooseAnotherTime} style='w-full !mb-0 mt-6'>
          <FormattedMessage id='slotTaken.backButton' />
        </ButtonLoading>
      </div>
    </Modal>
  )
}
